import styled from "styled-components";
import device from "src/constants/media";
import { typography, colors } from "src/theme";

const DatePickerContainer = styled.div`
  .react-calendar {
    width: 280px;
    border: none;
    padding: 24px;
    box-shadow: 0px 8px 64px -32px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    @media ${device.mobileM} {
      width: 320px;
    }
  }

  .react-calendar__navigation button {
    min-width: 0;
  }

  .react-calendar__navigation__prev-button {
    width: 40px;
    height: 40px;
    border: 2px solid ${colors.greyVeryLight};
    box-sizing: border-box;
    border-radius: 200px;
  }

  .react-calendar__navigation__next-button {
    width: 40px;
    height: 40px;
    border: 2px solid ${colors.greyVeryLight};
    box-sizing: border-box;
    border-radius: 200px;
  }

  .react-calendar__navigation__label {
    font-family: ${typography.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: ${colors.greyDark};
  }

  .react-calendar__month-view__days__day--weekend {
    color: #37393c;
    &:disabled {
      color: ${colors.greyLight};
    }
  }

  .react-calendar__month-view__days {
    border: 1px solid ${colors.greyVeryLight};
  }

  .react-calendar__tile {
    width: 39px;
    height: 39px;
    padding: 0;
    font-family: ${typography.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    border: 1px solid ${colors.greyVeryLight};
    &:disabled {
      background-color: ${colors.white};
    }
    &:hover {
      background-color: ${colors.mainLight};
    }
  }

  .react-calendar__navigation {
    margin-bottom: 0;
  }

  .react-calendar__month-view__weekdays__weekday {
    width: 39px;
    height: 39px;
    font-family: ${typography.fontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${colors.grey};
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background-color: #d5e1fc !important;
    color: ${colors.greyDark};
  }
  abbr[title] {
    text-decoration: none;
  }

  .react-calendar__tile--now,
  .react-calendar__tile--now,
  .react-calendar__navigation button[disabled] {
    background-color: ${colors.white};
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: ${colors.white};
  }

  .react-calendar__month-view__weekdays {
    text-transform: none;
  }

  .react-calendar__tile--active {
    background-color: ${colors.mainLight};
    color: ${colors.greyDark} !important;
  }
`;
export default DatePickerContainer;
